import React from 'react'

const MobileWizardHeader = () => (
  <div className="pt-4 pb-2 flex flex-col items-center text-center">
    <h2 className="text-xl font-extrabold text-base-gray-text-main">Request Quote</h2>
    <p className="text-sm font-medium text-base-gray-text-main">
      Send your job details and schedule. Get a response with a quote or next steps from the provider below.
    </p>
  </div>
)

export default MobileWizardHeader
